module.exports = __webpack_public_path__ + "static/media/vip.4c156fc8.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_190/images/悬浮窗/vip.png
// module id = 1656
// module chunks = 0